import {inject, Injectable} from './di';
import {AppInitializeService} from './app-initialize-service';
import {Logger} from './logger';
import {ConfigService} from './config/config-service';
import {LegacyLogService} from './logger/legacy-log-service';

/**
 * Preload fonts to avoid layout shifts
 */
@Injectable()
export class FontPreloadingService implements AppInitializeService {
  private readonly logger = inject(Logger);
  private readonly configService = inject(ConfigService);
  private readonly legacyLogService = inject(LegacyLogService);

  public async init(): Promise<boolean> {
    try {
      const config = this.configService.config;

      let fonts = config.tv?.hacks?.preload_fonts;

      if (!fonts) {
        return Promise.resolve(true);
      }

      if (typeof fonts === 'string') {
        fonts = [fonts];
      }

      if (!Array.isArray(fonts)) {
        this.logger.error(
          `[FontPreloadingService] "config.tv.hacks.preload_fonts" configuration value should be string[], but it is "${typeof fonts}"`,
        );
        this.legacyLogService.add('UI: config.tv.hacks.preload_fonts incorrect'); // todo legacy
        return Promise.resolve(true);
      }

      if (!fonts.length) {
        return Promise.resolve(true);
      }

      // Пререндер шрифтов, чтобы не прыгал текст и не слетал курсор
      //TODO: ??? preload default font with empty span
      //TODO: ??? preload bold
      //TODO: ??? preload RCU and other modules fonts
      const html = fonts.map((font) => `<span style="font-family: ${font};"></span>`).join('');
      $(document.body).append('<div style="opacity:0;position: absolute;top: 0px;">' + html + '</div>');
    } catch (err) {
      this.logger.error('[FontPreloadingService] Unable to initialize', err);
    }

    return Promise.resolve(true);
  }
}
